var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelpIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_8667",
    "data-name": "Group 8667",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.001,
    height: 17.001,
    viewBox: "0 0 17.001 17.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3355",
    "data-name": "Path 3355",
    d: "M0,0H17V17H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3356",
    "data-name": "Path 3356",
    d: "M16.167,12.627a4.252,4.252,0,0,1-3.339,4.151l-.452-1.356a2.836,2.836,0,0,0,1.995-1.38H12.626a1.417,1.417,0,0,1-1.417-1.417V9.792a1.417,1.417,0,0,1,1.417-1.417h2.081a5.668,5.668,0,0,0-11.246,0H5.542A1.417,1.417,0,0,1,6.959,9.792v2.833a1.417,1.417,0,0,1-1.417,1.417H3.417A1.417,1.417,0,0,1,2,12.626V9.084a7.084,7.084,0,0,1,14.167,0Zm-1.417,0V9.792H12.626v2.833ZM3.417,9.792v2.833H5.542V9.792Z",
    transform: "translate(-0.583 -0.583)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/helpIcon.3d9b28a22af04b058c427c299bda762e.svg";
export { ForwardRef as ReactComponent };